import { render, staticRenderFns } from "./edit-resources.component.html?vue&type=template&id=63c33353&scoped=true&"
import script from "./edit-resources.component.ts?vue&type=script&lang=ts&"
export * from "./edit-resources.component.ts?vue&type=script&lang=ts&"
import style0 from "./edit-resources.component.scss?vue&type=style&index=0&id=63c33353&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c33353",
  null
  
)

export default component.exports